
export default function TopicPracticePage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">TopicPractice</h1>
      <div className="card">
        <div className="card-content">
          <p className="text-gray-600">TopicPractice content will be available here.</p>
        </div>
      </div>
    </div>
  );
}
